import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SpecraButton } from '@mono/ui-components';
import { Testids } from '@mono/ui-selectors';
import { RefreshCw } from 'lucide-react';
import { toast } from 'sonner';
import { useReextractIntelligence } from '../hooks/intelligenceHooks';
/**
 * Re-runs IDP extraction for a score/document when the user has edit access.
 * Creates a fresh IntelligenceRun (or retries a failed one) and starts extraction.
 */ export function IntelligenceReextractButton({ workflowKind, target, sourceArtifactId, sourceArtifactIds, canEdit, label = 'Re-extract from document', description = 'Re-runs field extraction against the attached source document.', testId = Testids.deliveryQuality.intelligenceReextractButton, verb = 'Re-extract', onStarted }) {
    const { reextract, running } = useReextractIntelligence();
    if (!canEdit) return null;
    const artifactIds = sourceArtifactIds ?? (sourceArtifactId ? [
        sourceArtifactId
    ] : []);
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex flex-wrap items-center justify-between gap-3 rounded-lg border border-border bg-muted/20 px-4 py-3",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                children: [
                    /*#__PURE__*/ _jsx("p", {
                        className: "text-sm font-medium text-foreground",
                        children: label
                    }),
                    /*#__PURE__*/ _jsx("p", {
                        className: "text-xs text-muted-foreground",
                        children: description
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(SpecraButton, {
                type: "button",
                variant: "secondary",
                size: "sm",
                disabled: running || artifactIds.length === 0,
                onClick: ()=>void reextract({
                        workflowKind,
                        target,
                        sourceArtifactIds: artifactIds
                    }).then((run)=>{
                        onStarted?.(run);
                        toast.success(`${verb} started — proposals will appear when ready.`);
                    }).catch((err)=>toast.error(err instanceof Error ? err.message : `${verb} failed to start`)),
                "data-testid": testId,
                children: [
                    /*#__PURE__*/ _jsx(RefreshCw, {
                        className: `mr-2 h-4 w-4 ${running ? 'animate-spin' : ''}`
                    }),
                    running ? 'Starting…' : verb
                ]
            })
        ]
    });
}
